import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {getCurrentLang} from "./services/StorageService.tsx";
import i18nBackend from "i18next-http-backend";
import {constants} from "./general/constants.tsx";

const host = constants.APP_BASE_URL + import.meta.env.MODE === "development" ? ':5172' : '';

i18n
    .use(i18nBackend)
    .use(initReactI18next).init({
    lng: getCurrentLang(),
    fallbackLng: "fa",

    interpolation: {
        escapeValue: false,
    },
    backend: {
        loadPath: `${host}/languages/{{lng}}.json?v=${constants.APP_VERSION}`
    }
});

export default i18n;